
import './datatable.tag'
import './bs-pagination.tag'
riot.tag2('catalog-static', '  <div class="row" if="{!opts.removeToolbar}">\n    <div class="col-md-12">\n      <div class="form-inline m-b-3">\n        <div class="form-group" if="{opts.add}">\n          <button class="btn btn-primary" onclick="{add}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n        </div>\n        <yield from="toolbar"></yield>\n        <div class="form-group">\n          <button class="btn btn-danger" if="{opts.remove &amp;&amp; selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n          <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderNext}" title="Вниз" type="button"><i class="fa fa-arrow-down"></i></button>\n          <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderPrev}" title="Вверх" type="button"><i class="fa fa-arrow-up"></i></button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <div class="{opts.responsive == &quot;false&quot; ? &quot;&quot; : &quot;table-responsive&quot;}">\n        <datatable cols="{opts.cols}" rows="{items}" handlers="{opts.handlers}" dblclick="{opts.dblclick}" reorder="{opts.reorder}">\n          <yield from="body"></yield>\n        </datatable>\n      </div>\n    </div>\n  </div>\n  <div class="row" if="{value.length &gt; pages.limit}">\n    <div class="col-md-12">\n      <bs-pagination onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var _this2 = this;

var self = this;

self.mixin('permissions');
self.value = [];
self.items = [];

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value || [];
    },
    set: function set(value) {
        self.value = value || [];
        self.update();
    }
});

self.pages = {
    count: 0,
    current: 1,
    limit: 15,
    change: function change(e) {
        self.pages.current = e.currentTarget.page;
    }
};

if (opts.limit) self.pages.limit = opts.limit;

self.getPageItems = function () {
    var count = self.value.length;

    self.pages.count = Math.ceil(count / self.pages.limit);

    if (self.pages.current > self.pages.count) self.pages.current = self.pages.count;

    self.pages.current = self.pages.current == 0 ? 1 : self.pages.current;

    var offset = (self.pages.current - 1) * self.pages.limit;
    var end = offset + self.pages.limit;

    var items = self.value.filter(function (item, i) {
        return i > offset - 1 && i < end;
    });

    return items;
};

self.add = function () {
    if (typeof opts.add === 'function') {
        opts.add.bind(self)();
    }
};

self.remove = function (e) {
    self.selectedCount = 0;
    if (typeof opts.remove === 'function') {
        var _this = _this2,
            itemsToRemove = [];

        _this.items.forEach(function (item, i, arr) {
            if (item.__selected__ == true) itemsToRemove.push(item);
        });
        opts.remove.bind(_this2, e, itemsToRemove)();
    } else {
        (function () {
            var items = self.tags.datatable.getSelectedRows();

            self.value = self.value.filter(function (item) {
                return items.indexOf(item) === -1;
            });

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);

            if (typeof opts.afterRemove === 'function') {
                opts.afterRemove.bind(self)();
            }
        })();
    }
};
/*
self.remove = () => {
    self.selectedCount = 0

    let items = self.tags.datatable.getSelectedRows()

    self.value = self.value.filter(item => {
        return items.indexOf(item) === -1
    })

    let event = document.createEvent('Event')
    event.initEvent('change', true, true)
    self.root.dispatchEvent(event)

    if (typeof(opts.afterRemove) === 'function') {
        opts.afterRemove.bind(self)()
    }
}
*/

self.reorderNext = function () {
    self.tags.datatable.reorderNext();
};

self.reorderPrev = function () {
    self.tags.datatable.reorderPrev();
};

self.on('update', function () {
    if ('rows' in opts) {
        if (self.value !== opts.rows) self.selectedCount = 0;

        self.value = opts.rows || [];
        self.items = self.getPageItems(self.value) || [];
    }
});

self.one('updated', function () {
    self.tags.datatable.on('row-selected', function (count) {
        self.selectedCount = count;
        self.update();
    });
    self.tags.datatable.on('reorder-end', function () {
        self.value.forEach(function (item, index) {
            item.sort = index;
        });
    });
});

self.on('mount', function () {
    if (opts.name) self.root.name = opts.name;
});
});


// WEBPACK FOOTER //
// ./components/catalog-static.tag